import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IQuestion } from '../../../../interfaces/question.interface';

@Component({
  selector: 'app-choices-multiple-answer',
  templateUrl: './choices-multiple-answer.component.html',
  styleUrls: ['./choices-multiple-answer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChoicesMultipleAnswerComponent {
  @Input() question: IQuestion;
  @Input() withComment = false;
}
